import {
  CLOSE_DIALOG,
  MERGE_PATIENTS,
  MERGE_PATIENTS_ERROR,
  MERGE_PATIENTS_SUCCESS,
  OPEN_DIALOG,
  SEARCH_PATIENTS,
  SEARCH_PATIENTS_ERROR,
  SEARCH_PATIENTS_SUCCESS,
} from './constants';

export const closeDialog = () => ({ type: CLOSE_DIALOG });

export const mergePatients = (body) => ({
  type: MERGE_PATIENTS,
  body,
});

export const mergePatientsError = (error) => ({
  type: MERGE_PATIENTS_ERROR,
  error,
});

export const mergePatientsSuccess = () => ({ type: MERGE_PATIENTS_SUCCESS });

export const openDialog = () => ({ type: OPEN_DIALOG });

export const searchPatients = (patientId, text) => ({
  type: SEARCH_PATIENTS,
  patientId,
  text,
});

export const searchPatientsError = (error) => ({
  type: SEARCH_PATIENTS_ERROR,
  error,
});

export const searchPatientsSuccess = (patients) => ({
  type: SEARCH_PATIENTS_SUCCESS,
  patients,
});
